import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) { }

  getConfiguration(){
    return this.http.get<any>(`${this._baseUrl}/configuration`,);
  }

  updateConfiguration(config){
    const form = new FormData();
    form.append("AppName", config.appName);
    form.append("TimeZone", config.timeZone);
    form.append("Currency", config.currency);
    form.append("StockReturnAllowedDays", config.stockReturnAllowedDays);
    form.append("DiselPricePerLiter", config.diselPricePerLiter);
    form.append("UseNetQuantities", config.useNetQuantities);
    form.append("SkipKilometers", config.skipKilometers);    
    form.append("SkipOTP", config.skipOTP);    
    form.append("Logo", config.logo);
    form.append("AllowPartialSync", config.allowPartialSync);
    return this.http.patch<any>(`${this._baseUrl}/configuration`, form);
  }
}
